import { Content } from '../../../components/Basic/Global';
import { H1 } from '../../../components/Basic/WrapsStyle';
import ControlQualityTable from './Table';

const ControlQualityPage = () => {
  return (
    <Content>
      <H1>Проверка бухгалтерии</H1>
      <ControlQualityTable />
    </Content>
  );
};

export default ControlQualityPage;
